import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../tokens/cn';
import { focusRing, transitionBase } from '../tokens/variants';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, rows = 4, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'w-full bg-[var(--tk-surface-bg-elevated)] text-[var(--tk-surface-fg)]',
        'placeholder:text-[var(--tk-surface-fg-subtle)]',
        'border border-[var(--tk-surface-border-strong)] rounded-tk-md',
        'px-3.5 py-2.5 text-sm resize-y min-h-24',
        focusRing,
        transitionBase,
        'disabled:opacity-60 disabled:cursor-not-allowed',
        'aria-[invalid=true]:border-[var(--tk-danger-bg)] aria-[invalid=true]:focus-visible:ring-[var(--tk-danger-bg)]',
        className,
      )}
      {...props}
    />
  ),
);

Textarea.displayName = 'Textarea';
